import { render } from "./Animated-Headline.vue?vue&type=template&id=596472c3&scoped=true"
import script from "./Animated-Headline.vue?vue&type=script&lang=js"
export * from "./Animated-Headline.vue?vue&type=script&lang=js"

import "./Animated-Headline.vue?vue&type=style&index=0&id=596472c3&scoped=true&lang=css"

import exportComponent from "/Users/agroinnovatech/Development/Agro-Innova/AgroInnovaWebsite/AgroInnovaWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596472c3"]])

export default __exports__